<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="500">
			<v-card>
				<v-card-title class="text-h6" v-if="propAdd=='tambah'">Tambah Pengguna Supplier</v-card-title>
				<v-card-title class="text-h6" v-else>Edit Pengguna Supplier</v-card-title>
				<v-card-text class="pb-2">
					<v-row>
						<v-col cols="12" sm="12" md="12" class="py-0">
							<v-row>
								<v-col cols="12" class="text-center">
									<v-hover v-slot:default="{ hover }">
										<v-avatar color="grey" size="100">
											<img class="avatar" :src="image ? image : '/assets/user/profile-pict-menolak-big.png'">
											<v-expand-transition v-if="false">
												<div v-if="hover" class="d-flex transition-fast-in-fast-out primary v-card--reveal white--text" style="height: 100%;">
													<v-file-input dark color="white" prepend-icon="mdi-camera" hide-input hide-details class="icon-upload-avatar">
														<!-- <v-icon>mdi-camera</v-icon> -->
													</v-file-input>
												</div>
											</v-expand-transition>
										</v-avatar>
									</v-hover>
								</v-col>
								<v-col cols="12" sm="6" md="6" v-if="propAdd=='tambah'" class="pb-0">
									<v-text-field outlined dense @focus="() => responseError.username=''" :error-messages="responseError.username" v-model="paramAdd.username" label="Username" hint="Username minimal 6 karakter"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" md="6" class="pb-0">
									<v-autocomplete outlined dense @focus="() => responseError.supplier_id=''" :error-messages="responseError.supplier_id" v-model="paramAdd.supplier_id" :items="OptionSupplier" item-text="supplier_name" item-value="supplier_id" label="Supplier" item no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
								</v-col>
								<v-col cols="12" md="6" class="pb-0" v-if="false">
									<v-autocomplete class="text-capitalize" outlined dense @focus="() => responseError.type=''" :error-messages="responseError.type" v-model="paramAdd.type" :items="OptionType" item-text="type_name" item-value="type_name" label="Tipe Akun" item no-data-text="Tidak ada data yang sesuai">
										<template v-slot:item="{item}">
											<div class="text-capitalize">{{item.type_name}}</div>
										</template>
									</v-autocomplete>
								</v-col>
								<v-col cols="12" v-if="propAdd=='tambah'" sm="6" md="6" class="pb-0">
									<v-text-field outlined dense  @focus="() => responseError.password=''" :error-messages="responseError.password" v-model="paramAdd.password" label="Kata Sandi" type="password" hint="Kata Sandi minimal 6 karakter"></v-text-field>
								</v-col>
								<v-col cols="12" v-if="propAdd=='tambah'" sm="6" md="6" class="pb-0">
									<v-text-field outlined dense  @focus="() => responseError.repassword=''" :error-messages="responseError.repassword" v-model="paramAdd.repassword" label="Ulangi Kata Sandi" type="password"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" md="6" class="pb-0">
									<v-text-field outlined dense  @focus="() => responseError.name=''" :error-messages="responseError.name" v-model="paramAdd.name" label="Nama"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" md="6" class="pb-0">
									<v-text-field outlined dense  @focus="() => responseError.email=''" :error-messages="responseError.email" v-model="paramAdd.email" label="Email"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" md="6" class="pb-0">
									<v-text-field outlined dense @keypress="onlyNumber" @paste.prevent   @focus="() => responseError.mobilephone=''" :error-messages="responseError.mobilephone" v-model="paramAdd.mobilephone" label="No Handphone"></v-text-field>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="batal()">Batal</v-btn>
					<v-btn color="primary" depressed class="text-capitalize" @click="simpan">Simpan</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import {mapActions,  mapState, mapMutations} from 'vuex'
export default {
	data () {
		return {
			page: 1,
			limit: "10",
			hak: [],
			paramAdd: {
				username: '',
				password: '',
				repassword: '',
				name : '',
				email : '',
				mobilephone : '',
				supplier_id: '',
				type : '',
			},
			image: '',
		}
	},
	props: {
		value: Boolean,
		propAdd: String,
		edit: String,
		val: Object,
		filter: Object,
	},
	computed: {
		...mapState('supplierUser', ['responseError', 'responSukses', 'OptionSupplier', 'OptionType']),

		dialog: {
			get () {
				return this.value
			},
			set (value) {
				this.$emit('input', value)
			}
		},
	},
	methods: {
		...mapActions('supplierUser', ['getDataUser', 'add', 'update', 'getTypeOption']),
		...mapMutations('supplierUser', ['saveResponse']),
		...mapMutations(['setOverlay']),

		batal() {
			this.dialog = false
		},
		async simpan() {
			await this.setOverlay(true)
			if(this.paramAdd) {
				if(this.propAdd == 'tambah') {
					await this.add(this.paramAdd).then( () => {
						if(this.responSukses.code == 200) {
							this.getDataUser(this.queryString(this.filter))
							this.dialog= false
							this.reset()
						} else {
							this.dialog= true
						}
					})
				} else {
					await this.update(this.paramAdd).then( () => {
						if(this.responSukses.code == 200) {
							this.getDataUser(this.queryString(this.filter))
							this.dialog= false
							this.reset()
						} else {
							this.dialog= true
						}
					})
				}
			}
			await this.setOverlay(false)
		},
		reset () {
			this.saveResponse({})
			this.paramAdd.username = ''
			this.paramAdd.password = ''
			this.paramAdd.repassword = ''
			this.paramAdd.name  = ''
			this.paramAdd.email  = ''
			this.paramAdd.mobilephone  = ''
			this.paramAdd.supplier_id  = ''
			this.paramAdd.type  = ''
			this.image = ''
		}
	},
	watch: {
		val () {
			if (Object.keys(this.val).length > 0) {
				this.paramAdd.supplier_id  = this.val.user_supplier_supplier_id
				this.paramAdd.id = this.val.user_supplier_id
				this.paramAdd.name  = this.val.user_supplier_name
				this.paramAdd.email  = this.val.user_supplier_email
				this.paramAdd.mobilephone  = this.val.user_supplier_mobilephone
				this.paramAdd.type  = this.val.user_supplier_type
				this.image  = this.val.user_supplier_image
			} else {
				this.reset()
			}
		}
	},
	created() {
	}
}
</script>
